/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Filter_ActionInputs */

const fr_account_audit_filter_action = /** @type {(inputs: Account_Audit_Filter_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action requise`)
};

/**

* @param {Account_Audit_Filter_ActionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_filter_action = /** @type {((inputs?: Account_Audit_Filter_ActionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Filter_ActionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_filter_action(inputs)
});